// extracted by mini-css-extract-plugin
export default {"modal_title":"website_modal_title__Bknb-","modal":"website_modal__EAyAV","modal_btns":"website_modal_btns__eYYQz"};